import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "overflow-auto q-mb-sm" };
const _hoisted_2 = { class: "table table-bordered" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configuracionColumnas, (columna, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(columna.label), 1));
                    }), 128))
                ])
            ]),
            _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementos, (fila, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fila, (valor, clave) => {
                            return (_openBlock(), _createElementBlock("td", {
                                key: clave,
                                class: _normalizeClass({
                                    'bg-danger-celda': valor === 0 && clave + '' == 'deuda_vencida',
                                })
                            }, _toDisplayString(parseFloat(valor) + "" === "NaN"
                                ? valor
                                : parseFloat(valor).toFixed(2)), 3));
                        }), 128))
                    ]));
                }), 128))
            ])
        ])
    ]));
}
